
import Breadcrumbs from "~/components/UI/Breadcrumbs";
import {formaterOgTitle} from "~/helpers/formaterOgTitle";

export default {
  fetch: async function() {
    await this.getEvents(1);
  },
  head: function () {
    // если есть цмс страница, то устанавливаем от туда, если нет, то из 1-й карточки событий
    if (this.idPageEventSeo) {
      return null
    }

    const setHead = this.setHead;
    const title = setHead?.title || "Наш опыт — перевозки грузов";
    const description = setHead?.description || `Ознакомьтесь с последними событиями и выполненными перевозками различных грузов в ${this.cityName}, России и СНГ. Осуществляются перевозки грузов транспортной компанией Central Trans по РФ с гарантией качества`;

    return {
      title: title,
      meta: [
        {name: 'og:title', hid: 'og:title', property: 'og:title', content: formaterOgTitle(title, this.$store.state.appState.config)},

        {hid: 'metadescription', name: 'description', content: description},
        {hid: 'og:description', name: 'og:description', property: 'og:description', content: description}
      ],
    }
  },
  data() {
    return {
      events: [],

      pagination: {
        page: 1,
        totalPage: 1,
      },

      isLoad: true,
      
      idPageEventSeo: Number.parseFloat(this.$store.state?.appState?.vars?.['ID_PAGE_EVENTS_SEO'] || '0') 
    };
  },
  components: {
    Breadcrumbs,
    EventCard: () => import("~/components/events/EventCard.vue"),
    Pagination: () => import("~/components/UI/Pagination.vue"),
  },

  computed: {
    breadcrumbs: function() {
      return [
        { title: "Главная", path: "/" },
        { title: "Наши события", path: this.$route.fullPath },
      ];
    },
    setHead: function () {
      const events = this.events?.[0] || {};
      const eventsSeo = events || {};

      return {
        title: eventsSeo?.seo_title,
        description: eventsSeo?.seo_description,
      };
    },
    cityName: function () {
      return this.$store.state?.appState?.config?.city?.data?.city_name;
    },
  },

  methods: {
    getEvents: async function (newPage) {
      this.isLoad = true;

      const page = newPage || this.$route.query?.page || this.pagination.page;
      const response = await this.$api.agent.transport.get('/event?sort=-created_at').then((res) => {
        return res
      }).catch(() => {
        return {}
      });

      const pagination = {
        page: Number.parseFloat(response?.headers?.['x-pagination-current-page'] || 1),
        totalPage: Number.parseFloat(response?.headers?.['x-pagination-page-count'] || 1),
      };
      const events = response?.data || [];
      //this.setSearchParams(pagination.page); // @FIXME пока не определился нужно ли ?

      this.events = events;
      this.pagination = pagination;
      this.isLoad = false;
    },
    changePage: async function (newPage) {
      let pagination = {...this.pagination}
      pagination.page = newPage;
      this.pagination = pagination;

      const listPosition = this.$refs.refList.getBoundingClientRect()?.top + document.body.scrollTop;
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });

      await this.getEvents(newPage);
    },
  }
};
